import React from "react";
import { Col, Row } from "react-bootstrap";

import shiftup2 from "../../Assets/Projects/shiftup2.gif";
import travis_county from "../../Assets/Projects/Travis_County.png";
import austin_city from "../../Assets/Projects/Austin_City.png";
import san_marcos from "../../Assets/Projects/San_Marcos_Library.png";
import crimson_ark from "../../Assets/Projects/crimson_ark.png";
import urban_alchemy from "../../Assets/Projects/Urban-Alchemy.jpg"
import code_soil from "../../Assets/Projects/code&soil.png"
import montopolis from "../../Assets/Projects/Montopolis.jpg"
import unrulr from "../../Assets/Projects/Unrulr.png"
import insight from "../../Assets/Projects/Insight.png"
import mido from "../../Assets/Projects/Mido.png"
import techkids from "../../Assets/Projects/TechKidsUltd.png"
import ldg from "../../Assets/Projects/LDG.png"
import centro from "../../Assets/Projects/Centro.png"
import assist from "../../Assets/Projects/Assist.png"
import favrhood from "../../Assets/Projects/favrhood_logo1.png"

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
      <img src={travis_county} alt="about" className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <img src={austin_city} alt="about" className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <img src={shiftup2} alt="about" className="img-fluid" />      
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <img src={san_marcos} alt="about" className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        Crimson Ark Studio
        <img src={crimson_ark} alt="about" className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">       
        <img src={favrhood} alt="about" className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={urban_alchemy} alt="about" className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={code_soil} alt="about" className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={montopolis} alt="about" className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={unrulr} alt="about" className="img-fluid" />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <img src={insight} alt="about" className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={mido} alt="about" className="img-fluid" />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <img src={techkids} alt="about" className="img-fluid" />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <img src={ldg} alt="about" className="img-fluid" />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <img src={centro} alt="about" className="img-fluid" />
      </Col>
          <Col xs={4} md={2} className="tech-icons">
        <img src={assist} alt="about" className="img-fluid" />
      </Col>
    </Row>
  );
}

export default Toolstack;
